import { baseWebUrl, baseStrapiUrl } from "./assets/linkTree";
export default {
    title: "Castropol Web",
    viewName: "Home",
    // apiURL: window.location.protocol + "//" + window.location.host + "/api",
    // appURL: window.location.protocol + "//" + window.location.host, 
    apiURL: baseStrapiUrl +'/api',
    appURL: baseWebUrl,
    //seconds from expiry to try keepalive if activity detected, 
    //shall be below than expiry timeplapse from B-E
    secsToKA: 7200,
};